import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import * as _moment from 'moment';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {icons} from 'src/app/ui/icons';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {Router} from '@angular/router';

type Column = keyof any;

@Component({
    selector: 'app-etat-usine-four',
    templateUrl: './etat-usine-four.component.html',
    styleUrls: ['./etat-usine-four.component.css']
})
export class EtatUsineFourComponent implements OnInit {

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input() certif: any[];
    @Output() sort = new EventEmitter<any>();
    @Input() labels: Partial<Record<Column, string>>;
    displayedColumns: Column[] = [];
    dataSource = new MatTableDataSource<any>();
    @Input() mesinfos = false;
    displayedColumnsFR: Column[] = [
        'num',
        'factoryNm',
        'telNo',
        'faxNo',
        'postCd',
        'addr2'


    ];

    displayedColumnsAR: Column[] = [
        'num',
        'factoryNm',
        'telNo',
        'faxNo',
        'postCd',
        'addr2'

    ];
    displayedColumnsEN: Column[] = [
        'num',
        'factoryNm',
        'telNo',
        'faxNo',
        'postCd',
        'addr2'

    ];


    icons = icons;
    @Input() ondelete: boolean;

    constructor(
        private apptranstlte: AppTranslateService,
        private router: Router
    ) {
    }

    get readColumns() {
        if (this.getlang()) {
            this.displayedColumns = this.displayedColumnsAR;
        }
            // else if (this.apptranstlte.getDefaultLang() == 'en') {
            //   this.displayedColumns=this.displayedColumnsEN;
        // }
        else {
            this.displayedColumns = this.displayedColumnsFR;
        }
        return this.displayedColumns;
    }

    getlang() {
        return this.apptranstlte.getDefaultLang() == 'ar';
    }

    ngOnInit(): void {
        this.labels = {
            num: 'N°',
            factoryNm: 'Nom Usine',
            telNo: 'N° Téléphone Fixe',
            faxNo: 'N° Fax',
            postCd: 'Code Postal',
            addr2: 'Adresse'


        };

    }

    ngOnChanges(changes: SimpleChanges): void {
        const {certif} = changes;
        if (certif.currentValue !== certif.previousValue) {
            this.loadDataSource(certif.currentValue);
        }
    }

    loadDataSource(certif: any[]) {

        this.dataSource.data = certif;
        this.dataSource.data
            .filter(function($filter) {
                return function(date, format) {
                    if (date) {
                        return _moment(Number(date)).format(format || 'DD/MM/YYYY');
                    } else {
                        return '';
                    }
                };
            });

    }


    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;

    }
}

function newEventEmitter<T>() {
    throw new Error('Function not implemented.');
}
